export function restrictedThemes(themes: string[]) {
  const theme = process.env.VUE_APP_THEME_NAME
  return themes.includes(theme)
}
